import styled from 'styled-components';

export const BottomContent = styled.div`
  text-align: center;
`;
